const googleApiSupportedLangs = [
  'ar',
  'be',
  'bg',
  'bn',
  'ca',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'en-Au',
  'en-GB',
  'es',
  'eu',
  'fa',
  'fi',
  'fil',
  'fr',
  'gl',
  'gu',
  'hi',
  'hr',
  'hu',
  'id',
  'it',
  'iw',
  'ja',
  'kk',
  'kn',
  'ko',
  'ky',
  'lt',
  'lv',
  'mk',
  'ml',
  'mr',
  'my',
  'nl',
  'no',
  'pa',
  'pl',
  'pt',
  'pt-BR',
  'pt-PT',
  'ro',
  'ru',
  'sk',
  'sl',
  'sq',
  'sr',
  'sv',
  'ta',
  'te',
  'th',
  'tl',
  'tr',
  'uk',
  'uz',
  'vi',
  'zh-CN',
  'zh-TW',
]

export default googleApiSupportedLangs
